import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Názov programu")
], -1)
const _hoisted_3 = { class: "row g-9 mb-8" }
const _hoisted_4 = { class: "col-md-4 fv-row" }
const _hoisted_5 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_6 = { class: "col-md-4 fv-row" }
const _hoisted_7 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_8 = { class: "col-md-4 fv-row" }
const _hoisted_9 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_10 = { class: "row g-9 mb-7" }
const _hoisted_11 = { class: "col-md-4 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Spôsob určenia začiatku programu", -1)
const _hoisted_13 = { class: "col-md-4 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Spôsob určenia trvania programu", -1)
const _hoisted_15 = {
  key: 0,
  class: "col-md-4 fv-row"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Počet dní trvania programu", -1)
const _hoisted_17 = { class: "row g-9" }
const _hoisted_18 = { class: "d-flex flex-column fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Popis programu")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _component_npxForm = _resolveComponent("npxForm")!

  return (_openBlock(), _createBlock(_component_npxForm, {
    cardWrapper: "1",
    multilanguage: "1",
    pageTitleNew: "Nový program donášky",
    pageSubtitleNew: "Vyplňte povinné polia, pre pridanie nového programu donášky.",
    pageTitleEdit: "Upraviť program donášky",
    pageSubtitleEdit: "Vyplňte povinné polia, pre úpravu programu donášky.",
    listPageRouter: "programs",
    firestoreCollection: "programs",
    fieldValues: _ctx.localFieldValues,
    fieldRules: _ctx.localFieldRules
  }, {
    default: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, { prop: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.localFieldValues.title[slotProps.language.shortcut],
              "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.title[slotProps.language.shortcut]) = $event),
              placeholder: "Vložte názov programu",
              name: 'title.' + [slotProps.language.shortcut]
            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
          ]),
          _: 2
        }, 1024)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, "Cena za deň / 3 jedlá (" + _toDisplayString(slotProps.language.currency.toUpperCase()) + " s DPH)", 1),
          _createVNode(_component_el_form_item, { prop: "price_per_day_3_meals" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.localFieldValues.price_per_day_3_meals[slotProps.language.shortcut],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.price_per_day_3_meals[slotProps.language.shortcut]) = $event),
                placeholder: "Vložte cenu",
                name: 'price_per_day_3_meals.' + [slotProps.language.shortcut],
                precision: 2,
                step: 0.01
              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "step"])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, "Cena za deň / 5 jedál (" + _toDisplayString(slotProps.language.currency.toUpperCase()) + " s DPH)", 1),
          _createVNode(_component_el_form_item, { prop: "price_per_day_5_meals" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.localFieldValues.price_per_day_5_meals[slotProps.language.shortcut],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.price_per_day_5_meals[slotProps.language.shortcut]) = $event),
                placeholder: "Vložte cenu",
                name: 'price_per_day_5_meals.' + [slotProps.language.shortcut],
                precision: 2,
                step: 0.01
              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "step"])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, "Príplatok za bezlepkovú verziu (" + _toDisplayString(slotProps.language.currency.toUpperCase()) + " s DPH)", 1),
          _createVNode(_component_el_form_item, { prop: "price_fee_gf" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.localFieldValues.price_fee_gf[slotProps.language.shortcut],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.price_fee_gf[slotProps.language.shortcut]) = $event),
                placeholder: "Vložte cenu",
                name: 'price_fee_gf.' + [slotProps.language.shortcut],
                precision: 2,
                step: 0.01
              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "step"])
            ]),
            _: 2
          }, 1024)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_el_form_item, { prop: "start_by_customer" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.localFieldValues.start_by_customer[slotProps.language.shortcut],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.start_by_customer[slotProps.language.shortcut]) = $event),
                "active-color": "#13ce66",
                "inactive-color": "#409eff",
                "active-text": "Zvolený zákazníkom",
                "inactive-text": "Podľa cyklu",
                name: 'start_by_customer.' + [slotProps.language.shortcut]
              }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_el_form_item, { prop: "duration_by_customer" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.localFieldValues.duration_by_customer[slotProps.language.shortcut],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.duration_by_customer[slotProps.language.shortcut]) = $event),
                "active-color": "#13ce66",
                "inactive-color": "#409eff",
                "active-text": "Zvolený zákazníkom",
                "inactive-text": "Pevne stanovený",
                name: 'duration_by_customer.' + [slotProps.language.shortcut]
              }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
            ]),
            _: 2
          }, 1024)
        ]),
        (!_ctx.localFieldValues.duration_by_customer[slotProps.language.shortcut])
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_el_form_item, { prop: "duration_in_days" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.localFieldValues.duration_in_days[slotProps.language.shortcut],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.duration_in_days[slotProps.language.shortcut]) = $event),
                    placeholder: "Vložte počet dní",
                    name: 'duration_in_days.' + [slotProps.language.shortcut]
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                ]),
                _: 2
              }, 1024)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_el_form_item, { prop: "description" }, {
            default: _withCtx(() => [
              _createVNode(_component_ckeditor, {
                editor: _ctx.editor,
                modelValue: _ctx.localFieldValues.description[slotProps.language.shortcut],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localFieldValues.description[slotProps.language.shortcut]) = $event),
                config: _ctx.editorConfig
              }, null, 8, ["editor", "modelValue", "onUpdate:modelValue", "config"])
            ]),
            _: 2
          }, 1024)
        ])
      ])
    ]),
    _: 1
  }, 8, ["fieldValues", "fieldRules"]))
}